<template>
  <div>
    <!-- <Tabs type="card">
      <TabPane label="项目列表">
        
      </TabPane>
      <TabPane label="项目取消审核">

      </TabPane>
    </Tabs> -->
    <project-table ref="projectTable" :operateColumns="operateColumns" :extraQuery="extraQuery"></project-table>
    <Modal v-model="projectVisible" title="项目信息" width="950">
      <project-card :projectData="projectData" :showBack="false"></project-card>
    </Modal>
  </div>
</template>

<script>
import ProjectTable from '@/components/projectTable'
import ProjectCard from '@/views/documentation/projectCard'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { getProjectPermission } from "@/lib/projectPermission"

export default {
  components: {
    ProjectTable,
    ProjectCard
  },
  data() {
    return {
      operateColumns: [
        {
          title: '操作',
          width: 154,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.viewProject(params.row)
                  }
                }
              }, '查看信息'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.cancelProject(params.row)
                  }
                }
              }, '取消'),
            ])
          }
        }
      ],
      extraQuery: {
        status: ' and (projectState == "预立项" or projectState == "等待用户需求" or projectState == "文件编制中" or projectState == "标书文件已完成"  or projectState == "审查通过可挂网" or (projectState == "已挂网文件售卖中" and bidPlatform == "新产品" and projectProperty == "市场调研"))',
        rolePermission: ''
      },
      projectData: {},
      projectVisible: false
    }
  },
  methods: {
    viewProject(row) {
      this.projectData = row
      this.projectVisible = true
    },
    cancelProject(row) {
      if (row.projectState === '已挂网文件售卖中') {
        if (!(row.bidPlatform == '新产品' && row.projectProperty == '市场调研')) {
          this.$Message.info('已挂网暂不可取消')
          return
        }
      }
      if (row.clMeetingRoom && row.clMeetingRoom.beginTime) {
        this.$Message.info('请先取消会议室预约')
        return
      }
      this.$Modal.confirm({
        title: '取消项目',
        content: `<div>是否要取消项目${row.projectName}？<span style="color:#ed4014">（此操作不可撤回）</span></div>`,
        onOk: async () => {
          this.$Spin.show()
          let rep = await ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
            id: row.id,
            projectState: '项目取消'
          })
          if (rep.data.success) {
            this.$Spin.hide()
            // 刷新页面
            this.$refs.projectTable.refreshProject()
          }
        }
      })

    }
  }
}
</script>
